module.exports = __webpack_public_path__ + "static/media/Picture.93e9759a.svg";